/**
 * Pure pieces of the Attach / Change Program (or Service) dialog
 * (`AttachServiceModal`), kept apart so they are testable without a DOM.
 */

type Named = { name?: string | null; title?: string | null };

/** "<Program> - <Variant>" — once when the variant is named like its program
 *  ("Hospital Administration (1 Year)" twice read as a glitch). */
export function dealNameFor(parent: Named | undefined, variant: Named): string {
  const parts = [parent?.name ?? parent?.title, variant.name]
    .map((s: unknown) => (typeof s === "string" ? s.trim() : ""))
    .filter(Boolean);
  if (parts.length === 2 && parts[0].toLowerCase() === parts[1].toLowerCase()) return parts[1];
  return parts.join(" - ");
}

export type DealDiscount = {
  discountType?: string | null;
  discountValue?: number | null;
  discountAmount?: number | null;
};

/**
 * The deal's financials for a picked variant. A first attach starts with no
 * discount; a CHANGE keeps the deal's: a percentage re-applies to the new
 * value, a fixed amount stays (capped at the new value, so net never goes
 * negative).
 */
export function variantFinancials(
  totalDealValue: number,
  keep: DealDiscount | null,
): { totalDealValue: number; netAmount: number; discountAmount: number } {
  const discountAmount = !keep
    ? 0
    : keep.discountType === "percentage"
      ? Math.round((totalDealValue * (Number(keep.discountValue) || 0)) / 100)
      : Math.min(Number(keep.discountAmount) || 0, totalDealValue);
  return { totalDealValue, netAmount: totalDealValue - discountAmount, discountAmount };
}
